// extracted by mini-css-extract-plugin
module.exports = {"hideIcon":"DocumentFilters_hideIcon__1TchJ"};